<script>

/**
 * Automodal 
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'
import addNewDetail from './elements/add-new-detail.vue'
import detailRow from './elements/detail-row.vue'
import {swalMSG} from '@/utils.js'
import { archetype, automodalHandler } from './archetype'

export default {
    name: 'automodal',

    components: {addNewDetail, detailRow},

    props: {
        conceptId: {
            type: [String, Number],
        }
    },

    data: () => {
        return {
            form: {
                id: null,
                detalleLista: []
            },
            asides: {
                // administradores: [],
                // distribuidores: [],
            }
        }
    },

    computed: {
        subTotal(){
            let subTotal = 0
            _.forEach(this.form.detalleLista, item => {
                subTotal += parseFloat(item.cantidad) * parseFloat(item.fullObject.precio)
            })
            return subTotal;
        },
        formArchetypeMD5(){
			return md5(JSON.stringify(this.cArchetype))
		},
        cArchetype(){
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(this.handleItem(itemsRow));
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },

    methods: {
        addingItem(item2add){
            let isInListIndex = _.findIndex(this.form.detalleLista, itemList => {
                return (itemList.fullObject.presentacion_id_pk_tipo == item2add.fullObject.presentacion_id_pk_tipo)
            })
            if(isInListIndex == -1) this.form.detalleLista.push(item2add);
            else  swalMSG('Presentación agregada a la lista anteriormente', 'warning');
        },
        handleItem(item){
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if(_.isObjectLike(item)){
                switch(item.key){
                }
            }
            return item;
        },
        getHandler(){
            return automodalHandler(this.conceptId)
        },
        refresh(){
            this.$emit('refresh');
        },
        checkAsides(){
            const asides = this.$refs.automodal.getAsides();
            if(!!asides){
                // this.asides.administradores = asides.administradores
                // this.asides.distribuidores = asides.distribuidores
            }
        },
        onDisplay(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },
        deleteDetailItem(item){
            let deletingIndex = _.findIndex(this.form.detalleLista, itemInList => {
                return (item.fullObject.presentacion_id_pk_tipo == itemInList.fullObject.presentacion_id_pk_tipo)
            })
            this.form.detalleLista.splice(deletingIndex, 1)
            // console.log('deleteDetailItem', item)
        }
    },

    watch: {
        'subTotal'(){
            this.form.precio_aproximado = this.subTotal
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form"  ref="automodal" size="xl" 
        :form-id="form.id" 
        :form-archetype="cArchetype" 
        :handler="getHandler()"  
        :allow-aside="true" 
        :allow-delete="true"
        :form-key="formArchetypeMD5"
        @refresh="refresh()" 
        @defined="checkAsides()" 
        @display="onDisplay" 
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        
        <b-col slot="aside" cols="9">

            <add-new-detail @addingItem="addingItem"/>

            <div class="item-row" v-for="(item, $index) in form.detalleLista" :key="item.presentacion_id_pk_tipo">
                <detail-row v-model="form.detalleLista[$index]"  @delete="deleteDetailItem"/>
            </div>

            <!-- {{ form.detalleLista }} -->
            
            <b-jumbotron class="mt-3 mb-0" header="Lista vacía" v-if="!form.detalleLista || !form.detalleLista.length">
                <p>Agrega con la herramienta de arriba</p>
                <b-button variant="primary" @click="refresh()">Recargar</b-button>
            </b-jumbotron>

        </b-col>
        <b-col slot="bottom" v-if="false">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>